<div class="reviews-home-wrapper">
  <div class="dashboard">
    <div class="card half-height">
      <div class="card-header">
        <h3>REPORTS</h3>
      </div>
      <hr/>
      <p>
Welcome to the Reviews page! This tool allows you to view metrics about your reviews, as well as to read and respond to them.
      </p>
    </div>
  </div>
</div>


